import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Dialog, DialogContent, DialogActions, DialogTitle, Button, TextField } from "@material-ui/core";
import ConfirmationDialog from './ConfirmationDialog';

const useStyles = theme => ({
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    text: {
        width: 250,
        margin: theme.spacing(0.5)
    }
});

const initialState = {
    username: '',
    login: '',
    email: ''
}

const ForgotPasswordDialog = ({open, onClose, classes, onSubmit}) => {
    const [confOpen, setConfOpen] = useState(false);
    const [state, setState] = useState(initialState);

    const handleSubmit = () => {
        setConfOpen(true);
        onSubmit && onSubmit(state);
    };

    const handleChange = (e) => {
        e.persist();
        setState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    };

    const handleConfClose = () => {
        setConfOpen(false);
        setState(initialState);
        onClose && onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                Nie pamiętam hasła
            </DialogTitle>
            <DialogContent>
                <div className={classes.content}>
                    <TextField
                        label="Użytkownik"
                        className={classes.text}
                        value={state.username}
                        name="username"
                        onChange={handleChange}
                    />
                    <TextField
                        label="Login"
                        className={classes.text}
                        value={state.login}
                        name="login"
                        onChange={handleChange}
                    />
                    <TextField
                        label="Email"
                        className={classes.text}
                        type="email"
                        value={state.email}
                        name="email"
                        onChange={handleChange}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    Zamknij
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                >
                    OK
                </Button>
            </DialogActions>
            <ConfirmationDialog
                open={confOpen}
                onClose={handleConfClose}
            />
        </Dialog>
    );
};

ForgotPasswordDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default withStyles(useStyles)(ForgotPasswordDialog);
